/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const AdvisorProfilePage = lazyLoad(
  () => import('./index'),
  module => module.AdvisorProfilePage,
);
